"use strict";

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.for-each");

var _themeSections = require("@shopify/theme-sections");

var _cssClasses = _interopRequireDefault(require("../helpers/cssClasses"));

var _utils = require("../helpers/utils");

var _toggle = _interopRequireDefault(require("../components/toggle"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * DOM selectors.
 */


var selectors = {
  childMenuToggle: '[js-menu-drawer="childMenuToggle"]',
  grandChildMenuToggle: '[js-menu-drawer="grandChildMenuToggle"]',
  submenus: 'ul.menu-drawer__menu-child.first_child',
  backButton: '.menu-drawer__child_header_back',
  closeButton: '.menu-drawer__close_menu'
};
/**
 * Instantiate menu drawer toggle.
 */

var MenuDrawer = (0, _toggle["default"])({
  toggleSelector: 'menuDrawerToggle',
  targetSelector: 'menuDrawerTarget',
  focusInput: false,
  appendOverlayTo: '#shopify-section-site-header'
});
/**
 * Component selectors.
 */

var menus = [].concat(_toConsumableArray(document.querySelectorAll(selectors.childMenuToggle)), _toConsumableArray(document.querySelectorAll(selectors.grandChildMenuToggle)));
var submenuElements = document.querySelectorAll(selectors.submenus);
(0, _themeSections.register)('menu-drawer', {
  /**
   * Initiate toggle events on all sub-menus.
   */
  constructAccordionMenus: function constructAccordionMenus() {
    var _this = this;

    _toConsumableArray(menus).forEach(function (element) {
      (0, _utils.on)('click', element, function (event) {
        return _this.onItemClick(event, element);
      });
    });
  },

  /**
   * Handle toggle event on menu item click.
   * @param {Event} event - Click event.
   * @param {HTMLElement} element - The menu item.
   */
  onItemClick: function onItemClick(event, element) {
    event.preventDefault();
    var isSubmenu = element.matches(selectors.childMenuToggle) || element.matches(selectors.grandChildMenuToggle);
    var sibling = (0, _utils.getSiblings)(element)[0];
    this.toggleElement(element, isSubmenu);

    if (sibling) {
      this.toggleElement(sibling, isSubmenu);
      document.documentElement.classList.add('menu-open');
    }
  },

  /**
   * Set listeners for each instance.
   */
  setListeners: function setListeners() {
    var _this2 = this;

    Frame.EventBus.listen(['Toggle:menuDrawerTarget:open'], function () {
      return document.documentElement.classList.add('menu-open');
    });
    Frame.EventBus.listen(['Toggle:menuDrawerTarget:close'], function () {
      return document.documentElement.classList.remove('menu-open');
    });
    Frame.EventBus.listen('MenuDrawer:closeSubmenus', function () {
      return _this2.closeSubmenus();
    });
  },

  /**
   * Set listeners for navigation buttons.
   */
  setListenersNav: function setListenersNav() {
    var _this3 = this;

    document.querySelectorAll(selectors.backButton).forEach(function (element) {
      (0, _utils.on)('click', element, function () {
        _this3.closeSubmenus();
      });
    });
    document.querySelectorAll(selectors.closeButton).forEach(function (element) {
      (0, _utils.on)('click', element, function () {
        _this3.closeSubmenus();

        MenuDrawer.close();
      });
    });
  },

  /**
   * Close submenus.
   */
  closeSubmenus: function closeSubmenus() {
    submenuElements.forEach(function (element) {
      return element.classList.remove(_cssClasses["default"].active);
    });
  },

  /**
   * Check if item is active.
   * @param {HTMLElement} element - The menu item.
   */
  isItemActive: function isItemActive(element) {
    return element.classList.contains(_cssClasses["default"].active);
  },

  /**
   * Toggle button state.
   * @param {HTMLElement} element - The toggled button.
   */
  toggleElement: function toggleElement(element, isSubmenu) {
    if (this.isItemActive(element)) {
      this.showMenu(element, isSubmenu);
    } else {
      this.hideMenu(element, isSubmenu);
    }
  },

  /**
   * Show menu.
   * @param {HTMLElement} element - The item to show.
   */
  showMenu: function showMenu(element, isSubmenu) {
    element.classList.remove(_cssClasses["default"].active);

    if (!isSubmenu) {
      Frame.EventBus.emit('Toggle:menuDrawerTarget:open');
    }
  },

  /**
   * Hide menu.
   * @param {HTMLElement} element - The item to hide.
   */
  hideMenu: function hideMenu(element, isSubmenu) {
    element.classList.add(_cssClasses["default"].active);

    if (!isSubmenu) {
      Frame.EventBus.emit('Toggle:menuDrawerTarget:close');
    }
  },

  /**
   * Initialise section.
   */
  init: function init() {
    MenuDrawer.init();
    this.constructAccordionMenus();
  },

  /**
   * Event callback for Theme Editor `section:select` event
   */
  onSelect: function onSelect() {
    MenuDrawer.open();
  },

  /**
   * Event callback for Theme Editor 'shopify:section:deselect' event.
   */
  onDeselect: function onDeselect() {
    MenuDrawer.close();
  },

  /**
   * Event callback for Theme Editor `section:load` event
   */
  onLoad: function onLoad() {
    this.init();
    this.setListeners();
    this.setListenersNav();
  }
});